import { List, Map } from 'immutable';
import { FACETS_DATA_ERROR as SEARCH_FACETS_DATA_ERROR, RECEIVE_FACETS as SEARCH_RECEIVE_FACETS } from '../../common/actions/Search';
import { FACETS_DATA_ERROR as DISCOVER_FACETS_DATA_ERROR, RECEIVE_FACETS as DISCOVER_RECEIVE_FACETS } from '../actions/Discover';
const initialState = Map({
  dataError: false,
  dataErrorMessages: List(),
  initialized: false,
  facets: undefined
});
export default function SearchContainerReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case DISCOVER_RECEIVE_FACETS:
    case SEARCH_RECEIVE_FACETS:
      return state.set('initialized', true).set('facets', action.facets).set('dataError', false);
    case DISCOVER_FACETS_DATA_ERROR:
    case SEARCH_FACETS_DATA_ERROR:
      return state.set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
    default:
      return state;
  }
}